import { useEffect, useState } from "react";

async function api(path, options) {
  return fetch(path, { credentials: "same-origin", headers: { "Content-Type": "application/json" }, ...options });
}

export function Subscribers({ chapterId, canManage }) {
  const [subs, setSubs] = useState(null);

  function load() {
    api(`/api/chapters/${chapterId}/subscribers`)
      .then((res) => (res.ok ? res.json() : { subscribers: [] }))
      .then((data) => setSubs(data.subscribers));
  }
  useEffect(load, [chapterId]);

  async function remove(s) {
    if (!window.confirm(`Remove ${s.email}?`)) return;
    await api(`/api/subscribers/${s.id}`, { method: "DELETE" });
    load();
  }

  if (subs === null) return <p className="muted">Loading…</p>;

  return (
    <>
      <div className="section-head">
        <h3>Newsletter subscribers · {subs.length}</h3>
        {subs.length > 0 && (
          <a className="btn-ghost" style={{ padding: "6px 12px", borderRadius: 8, textDecoration: "none" }} href={`/api/chapters/${chapterId}/subscribers/export`}>
            Export CSV
          </a>
        )}
      </div>
      {subs.length ? (
        <table className="tbl">
          <thead><tr><th>Email</th><th>Name</th><th>Subscribed</th>{canManage && <th />}</tr></thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id}>
                <td>{s.email}</td>
                <td className="muted">{s.name || "—"}</td>
                <td className="muted">{s.subscribed_at.slice(0, 10)}</td>
                {canManage && (
                  <td className="row-actions">
                    <button className="btn-danger" type="button" onClick={() => remove(s)}>Remove</button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="empty">No subscribers yet.</p>
      )}
    </>
  );
}
